<div
  class="progress flex flex-row bg-slate-50 rounded-full md:min-w-0"
  (mouseenter)="eventMouseEnter()"
  (mouseleave)="eventMouseLeave()"
>
  <ng-container *ngIf="progressData()">
    <ng-container
      *ngFor="let item of filteredData(); let first = first; let last = last"
    >
      <div
        class="flex flex-row justify-center items-center cursor-pointer"
        [class.rounded-l-full]="first"
        [class.rounded-r-full]="last"
        [style.background-color]="item.color"
        [style.min-width.px]="item.minWidth"
        [style.width.%]="item.width"
        [class]="item.customClass"
        (mouseenter)="eventMouseEnterColumn(item)"
        (mouseleave)="eventMouseLeaveColumn(item)"
        (click)="eventSegmentContainerClick(item)"
      >
        <!-- An interactive segment navigates (drilldown), so it must be a real button:
             focusable, operable with Enter/Space and announced with its own name. Static
             bars keep the plain markup so the many read-only bars across the apps do not
             gain tab stops, and their DOM shape stays exactly as before. -->
        <button
          *ngIf="interactive(); else staticBarText"
          type="button"
          class="w-full h-full flex flex-row justify-center items-center text-white text-xs font-semibold"
          [attr.aria-label]="item.ariaLabel || item.label"
          (click)="eventMouseClickColumn(item)"
        >
          {{item.barText}}
        </button>
        <ng-template #staticBarText>
          <div class="text-white text-xs font-semibold">{{item.barText}}</div>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>
</div>
